/**
 * DevExtreme (core/component_registrator_callbacks.js)
 * Version: 17.2.7
 * Build date: Fri Mar 16 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var MemorizedCallbacks = require("./memorized_callbacks");
module.exports = new MemorizedCallbacks;



//////////////////
// WEBPACK FOOTER
// ./node_modules/devextreme/core/component_registrator_callbacks.js
// module id = ./node_modules/devextreme/core/component_registrator_callbacks.js
// module chunks = vendor